import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './index.scss';

// 看一次即缓存，发新通知时改 key（如 update_notice_seen_v5）即可让用户重新看到
const UPDATE_NOTICE_SEEN_KEY = 'update_notice_seen_v5';

const UpdateNotice = () => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (location.pathname.startsWith('/admin')) return;
    if (location.pathname !== '/home') return;
    if (localStorage.getItem(UPDATE_NOTICE_SEEN_KEY)) return;
    const t = setTimeout(() => setVisible(true), 500);
    return () => clearTimeout(t);
  }, [location.pathname]);

  const handleClose = () => {
    setVisible(false);
    localStorage.setItem(UPDATE_NOTICE_SEEN_KEY, '1');
  };

  if (!visible) return null;

  return (
    <div className="update-notice-overlay" onClick={handleClose}>
      <div className="update-notice-content" onClick={(e) => e.stopPropagation()}>
        <div className="update-notice-header">
          <div className="update-notice-title">
            <span className="title-icon">🎉</span>
            <span className="title-text">学习内容升级啦</span>
          </div>
          <button className="update-notice-close" onClick={handleClose}>×</button>
        </div>
        <div className="update-notice-body">
          <p className="update-notice-single">每天新关卡开放至30关，雷音寺课本同步内容已上线。</p>
        </div>
        <div className="update-notice-footer">
          <button className="update-notice-button" onClick={handleClose}>知道啦</button>
        </div>
      </div>
    </div>
  );
};

export default UpdateNotice;
